import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoTrash = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Trash</title>
    <path
      d="M20.57 7.272v-.571a2.286 2.286 0 0 0-2.284-2.286h-4.572a2.286 2.286 0 0 0-2.285 2.286v.571M24.697 12.415c-.366 3.389-1.27 10.239-1.796 14.176a3.421 3.421 0 0 1-3.393 2.966H12.49a3.42 3.42 0 0 1-3.394-2.966C8.568 22.638 7.662 15.757 7.3 12.415M18.286 16.987v6.286M13.715 16.987v6.286M5.714 10.13A2.286 2.286 0 0 1 8 7.845h15.999a2.286 2.286 0 0 1 2.286 2.285v.424c0 .631-.512 1.143-1.143 1.143H6.857a1.143 1.143 0 0 1-1.143-1.143v-.424Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoTrash;
